<script>
	import AttributionStats from './AttributionStats.svelte';
	import ChartNoColors from './ChartNoColors.svelte';
	import { DatePicker } from '@svelte-plugins/datepicker';
	import { attributionInpageElementsChart, attributionInpageElements } from '../utils/reports-api';

	const today = new Date();
	const MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;

	let startDate = new Date(Date.now() - 7 * MILLISECONDS_IN_DAY);
	let endDate = today;
	let selectedPageType = 'all';
	let selectedDevice = 'all';

	let isOpen = false;

	$: inpageElementsPromise = attributionInpageElementsChart(
		formatDateForAPI(startDate),
		formatDateForAPI(endDate),
		selectedDevice === 'all' ? null : selectedDevice,
		selectedPageType === 'all' ? null : selectedPageType
	);

	$: inpageElementsDataPromise = attributionInpageElements(
		formatDateForAPI(startDate),
		formatDateForAPI(endDate),
		selectedDevice === 'all' ? null : selectedDevice,
		selectedPageType === 'all' ? null : selectedPageType
	);

	function getBarChartConfig(data) {
		return {
			type: 'bar',
			responsive: false,
			maintainAspectRatio: true,
			data: {
				labels: data?.labels || [],
				datasets: !data?.datasets
					? []
					: data.datasets.map((dataset, index) => ({
							...dataset,
							backgroundColor: getColor(index)
					  }))
			},
			options: {
				responsive: true,
				scales: {
					x: {
						stacked: false
					},
					y: {
						stacked: false,
						beginAtZero: true
					}
				},
				plugins: {
					legend: {
						position: 'bottom'
					}
				}
			}
		};
	}

	function formatDate(date) {
		try {
			return new Date(date).toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'short',
				day: 'numeric'
			});
		} catch (error) {
			console.error('Error formatting date:', error);
			return 'Error';
		}
	}

	function formatDateForAPI(date) {
		try {
			const adjustedDate = new Date(date);
			const timezoneOffset = adjustedDate.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
			const localDate = new Date(adjustedDate.getTime() - timezoneOffset);
			return localDate.toISOString().split('T')[0];
		} catch (error) {
			console.error('Error formatting date for API:', error);
			return 'Error';
		}
	}

	$: formattedStartDate = formatDate(startDate);
	$: formattedEndDate = formatDate(endDate);

	const toggleDatePicker = () => (isOpen = !isOpen);

	const onClearDates = () => {
		startDate = new Date(Date.now() - 7 * MILLISECONDS_IN_DAY);
		endDate = new Date();
	};

	function getColor(index) {
		const colors = ['#FFB400', '#2FBFAB', '#FFE9B3', '#C1ECE6'];
		return colors[index % colors.length];
	}
</script>

<section class="bordered-section">
	<div class="chart-wrapper">
		<nav>
			<h2>Inpage Elements</h2>
			<div style="justify-content:flex-end;float:right;display:flex;gap:5px;">
				<select
					name="pageTypes"
					id="pageTypes"
					bind:value={selectedPageType}
					on:change={() => {
						// inpageElementsPromise = attributionInpageElementsChart(
						// 	formatDateForAPI(startDate),
						// 	formatDateForAPI(endDate),
						// 	selectedDevice === 'all' ? null : selectedDevice,
						// 	selectedPageType === 'all' ? null : selectedPageType
						// );
						// inpageElementsDataPromise = attributionInpageElements(
						// 	formatDateForAPI(startDate),
						// 	formatDateForAPI(endDate),
						// 	selectedDevice === 'all' ? null : selectedDevice,
						// 	selectedPageType === 'all' ? null : selectedPageType
						// );
					}}
				>
					<option value="all">All Page Types</option>
					<option value="product_grid">Product Grid</option>
					<option value="product_details">Product Details</option>
					<option value="other">Other</option>
					<option value="landing">Landing</option>
					<option value="homepage">Homepage</option>
					<option value="category">Category</option>
					<option value="cart">Cart</option>
					<option value="404">404</option>
				</select>
				<select
					name="device"
					id="device"
					bind:value={selectedDevice}
					on:change={() => {
						inpageElementsPromise = attributionInpageElementsChart(
							formatDateForAPI(startDate),
							formatDateForAPI(endDate),
							selectedDevice === 'all' ? null : selectedDevice,
							selectedPageType === 'all' ? null : selectedPageType
						);
						inpageElementsDataPromise = attributionInpageElements(
							formatDateForAPI(startDate),
							formatDateForAPI(endDate),
							selectedDevice === 'all' ? null : selectedDevice,
							selectedPageType === 'all' ? null : selectedPageType
						);
					}}
				>
					<option value="all">All Devices</option>
					<option value="desktop">Desktop</option>
					<option value="mobile">Mobile</option>
				</select>
				<DatePicker bind:isOpen bind:startDate bind:endDate isRange showPresets>
					<div class="date-field" on:click={toggleDatePicker} class:open={isOpen}>
						<i class="icon-calendar" />
						<div class="date">
							{formattedStartDate} - {formattedEndDate}
						</div>
						<span on:click={onClearDates}>
							<i class="os-icon-x" />
						</span>
					</div>
				</DatePicker>
			</div>
		</nav>

		<div class="chart" style="height: 400px;">
			{#await inpageElementsPromise}
				<span class="loader" />
			{:then barChartData}
				<ChartNoColors config={getBarChartConfig(barChartData)} />
			{:catch error}
				{error}
			{/await}
		</div>
	</div>

	{#await inpageElementsDataPromise}
		<div class="chart" style="height: 400px;"><span class="loader" /></div>
	{:then componentData}
		{#if componentData?.length > 0}
			{#each componentData as component}
				<div class="separator" />
				<div class="component-attribution">
					<h3>{component.element}</h3>
					<AttributionStats
						value={component.strong_attribution}
						percentage={component.attribution_percentage * 100}
					/>
				</div>
			{/each}
		{/if}
	{:catch error}
		{error}
	{/await}
</section>

<style>
	.separator {
		width: 100%;
		height: 1px;
		margin: 12px 0;
		background-color: #ddd;
	}
</style>
